<template>
  <div style="padding-top: 10px">
    <div v-loading="loading" :element-loading-text="loadingMsg"
         element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-spinner="el-icon-loading"
         style="max-width: 100%; margin: 10px auto;background: #fff;border-radius: 14px;min-height: 87vh;padding: 10px">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        商品SkuId：
        <div style="margin-left: 10px;margin-bottom: 10px">
          <el-input v-model="params.skuId" placeholder="请输入需要查询的商品SkuId"
                    size="mini" style="width: 200px"></el-input>
        </div>
        <div style="margin-left: 10px;margin-bottom: 10px">
          手机号：
          <el-input v-model="params.mobile" placeholder="请输入需要查询的手机号"
                    size="mini" style="width: 200px"></el-input>
        </div>
        <div style="margin-left: 10px;margin-bottom: 10px">
          状态：
          <el-input v-model="params.nickname" placeholder="请输入需要查询的名称"
                    size="mini" style="width: 200px"></el-input>
        </div>
        <div style="margin-left: 10px;margin-bottom: 10px">
          <el-date-picker
              v-model="value2"
              :picker-options="pickerOptions"
              align="right"
              end-placeholder="结束结束日期"
              range-separator="至"
              size="mini"
              start-placeholder="开始生成日期"
              type="datetimerange">
          </el-date-picker>
        </div>
        <div style="margin-left: 10px;margin-bottom: 10px">
          <el-button size="mini" type="primary" @click="getGoodPriceFeedBackList">搜索</el-button>
        </div>
        <div style="margin-left: 10px;margin-bottom: 10px">
          <el-button size="mini" @click="resetListParams">重置</el-button>
        </div>
      </div>
      <el-table
          :data="rows"
          style="width: 100%">
        <el-table-column
            fixed
            label="选品库信息"
            width="120">
          <template slot-scope="scope">
            <div class="d-flex align-items-center">
              <div class="symbol symbol-50px me-2">
                {{ scope.row.topicId }}
              </div>
              <div class="d-flex justify-content-start flex-column">
                {{ scope.row.topicName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="商品SkuId"
            prop="skuId"
            width="115">
        </el-table-column>
        <el-table-column label="信息" width="180px">
          <template slot-scope="scope">
            <div v-if="scope.row.isJd === 2">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-50px me-5">
                  <img :src="`https://www.1c-1g.cn${scope.row.picUrl}`" alt="">
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <el-tooltip :content="scope.row.title" placement="top">
                    <a :href="`https://item.jd.com/${scope.row.jdUrl}.html`"
                       class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                       target="_blank"
                    >{{ scope.row.title }}</a>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-50px me-5">
                  <img :src="scope.row.picUrl" alt="">
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <el-tooltip :content="scope.row.title" placement="top">
                    <a :href="scope.row.jdUrl"
                       class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                       target="_blank">
                      {{ scope.row.skuName }}
                    </a>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="用户名称"
            width="120"
            prop="nickName">
        </el-table-column>
        <el-table-column
            label="用户手机号"
            width="110"
            prop="mobile">
        </el-table-column>
        <el-table-column
            label="京东价"
            width="110"
            prop="price">
        </el-table-column>
        <el-table-column
            label="京东价"
            width="100"
            prop="price">
        </el-table-column>
        <el-table-column
            label="进货价"
            width="100"
            prop="costPrice">
        </el-table-column>
        <el-table-column
            label="反馈时京东价"
            width="110"
            prop="currentPrice">
        </el-table-column>
        <el-table-column
            label="反馈时进货价"
            width="110"
            prop="currentCostPrice">
        </el-table-column>
        <el-table-column
            label="状态"
            width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.feedBackStatus === 0" type="success">
              待审核
            </el-tag>
            <el-tag v-else-if="scope.row.feedBackStatus === 1" type="info">
              已通过
            </el-tag>
            <el-tag v-else-if="scope.row.feedBackStatus === 2" type="warning">
              已拒绝
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="反馈时间"
            width="100"
            prop="createTime">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="400px">
          <template slot-scope="{row}">
            <el-button size="mini" @click="feedBackIng(row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-size="0"
          :page-sizes="[10, 20, 30, 50]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 10px;text-align: center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 审核弹窗 -->
    <el-dialog
        :title="`审核商品价格反馈 - SKU: ${currentRow?.skuId}`"
        :visible.sync="auditDialogVisible"
        width="500px"
        :before-close="handleCloseDialog">
      <div v-if="currentRow">
        <el-divider content-position="left">商品信息</el-divider>
        <div class="product-info">
          <div class="d-flex align-items-center mb-3">
            <div class="symbol symbol-80px me-4">
              <img :src="currentRow.isJd === 2 ? `https://www.1c-1g.cn${currentRow.picUrl}` : currentRow.picUrl"
                   alt="商品图片" style="width: 80px; height: 80px; object-fit: contain;">
            </div>
            <div class="d-flex flex-column">
              <a :href="`https://item.jd.com/${currentRow.skuId}.html`" target="_blank">
                <span class="fw-bold mb-1">{{ currentRow.title || currentRow.skuName }}</span>
                <span class="text-muted">SKU: {{ currentRow.skuId }}</span>
              </a>
            </div>
          </div>

          <div class="price-info mb-4">
            <div class="row mb-2">
              <div class="col-6">
                <label class="text-muted">原京东价：</label>
                <span class="fw-bold text-danger">{{ currentRow.price }}元</span>
              </div>
              <div class="col-6">
                <label class="text-muted">原进货价：</label>
                <span class="fw-bold text-danger">{{ currentRow.costPrice }}元</span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="text-muted">反馈时京东价：</label>
                <span class="fw-bold text-warning">{{ currentRow.currentPrice }}元</span>
              </div>
              <div class="col-6">
                <label class="text-muted">反馈时进货价：</label>
                <span class="fw-bold text-warning">{{ currentRow.currentCostPrice }}元</span>
              </div>
            </div>
          </div>

          <el-divider content-position="left">审核操作</el-divider>
          <div class="audit-section">
            <div class="mb-3">
              <label class="d-block mb-2 fw-bold">设置新价格：</label>
              <div class="row mb-2">
                <div class="col-6">
                  <label class="text-muted">新京东价：</label>
                  <el-input-number
                      v-model="auditData.newPrice"
                      :min="0"
                      :precision="2"
                      size="small"
                      placeholder="请输入新京东价"
                      style="width: 120px">
                  </el-input-number>
                </div>
                <div class="col-6">
                  <label class="text-muted">新进货价：</label>
                  <el-input-number
                      v-model="auditData.newCostPrice"
                      :min="0"
                      :precision="2"
                      size="small"
                      placeholder="请输入新进货价"
                      style="width: 120px">
                  </el-input-number>
                </div>
              </div>
            </div>

            <div class="mb-4">
              <label class="d-block mb-2 fw-bold">审核备注：</label>
              <el-input
                  type="textarea"
                  v-model="auditData.remark"
                  :rows="3"
                  placeholder="请输入审核备注（可选）"
                  maxlength="200"
                  show-word-limit>
              </el-input>
            </div>

            <div class="d-flex justify-content-end">
              <el-button type="danger" size="small" @click="handleAuditReject" :loading="auditLoading">
                审核不通过
              </el-button>
              <el-button type="primary" size="small" @click="handleAuditPass" :loading="auditLoading" style="margin-left: 10px;">
                审核通过
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import sd from "silly-datetime";
import {
  getGoodPriceFeedBackApi

} from "@/api/backend/goodPriceFeedBackApi";


export default {
  name: "AppletGoodsPriceFeedBack",
  data() {
    return {
      value2: [],
      rows: [],
      size: 10,
      current: 1,
      total: 0,
      loading: false,
      loadingMsg: "列表加载中...",
      params: {
        current: 1,
        size: 10,
        skuId: "",
        mobile: ""
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 审核相关数据
      auditDialogVisible: false,
      currentRow: null,
      auditLoading: false,
      auditData: {
        newPrice: null,
        newCostPrice: null,
        remark: ""
      }
    }
  },
  filters: {
    formatDate(value) {
      return sd.format(+value)
    },
  },
  methods: {
    // 打开审核弹窗
    feedBackIng(row) {
      this.currentRow = {...row};
      this.auditData.newPrice = row.currentPrice || row.price;
      this.auditData.newCostPrice = row.currentCostPrice || row.costPrice;
      this.auditData.remark = "";
      this.auditDialogVisible = true;
    },

    // 审核通过
    async handleAuditPass() {
      if (!this.validateAuditData()) return;

      try {
        this.auditLoading = true;

        const auditParams = {
          id: this.currentRow.id,
          feedBackStatus: 1, // 通过
          newPrice: this.auditData.newPrice,
          newCostPrice: this.auditData.newCostPrice,
          remark: this.auditData.remark
        };

        // 调用审核接口
        const result = await auditGoodPriceFeedBackApi(auditParams);

        if (result.success) {
          this.$message({
            message: '审核通过成功',
            type: 'success'
          });
          this.auditDialogVisible = false;
          this.getGoodPriceFeedBackList(); // 刷新列表
        } else {
          this.$message.error(result.message || '审核失败');
        }
      } catch (error) {
        console.error('审核失败:', error);
        this.$message.error('审核失败，请重试');
      } finally {
        this.auditLoading = false;
      }
    },

    // 审核不通过
    async handleAuditReject() {
      try {
        this.auditLoading = true;

        const auditParams = {
          id: this.currentRow.id,
          feedBackStatus: 2, // 不通过
          remark: this.auditData.remark || "审核不通过"
        };

        // 调用审核接口
        const result = await auditGoodPriceFeedBackApi(auditParams);

        if (result.success) {
          this.$message({
            message: '已拒绝该反馈',
            type: 'success'
          });
          this.auditDialogVisible = false;
          this.getGoodPriceFeedBackList(); // 刷新列表
        } else {
          this.$message.error(result.message || '操作失败');
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败，请重试');
      } finally {
        this.auditLoading = false;
      }
    },

    // 验证审核数据
    validateAuditData() {
      if (!this.auditData.newPrice && this.auditData.newPrice !== 0) {
        this.$message.warning('请输入新京东价');
        return false;
      }

      if (!this.auditData.newCostPrice && this.auditData.newCostPrice !== 0) {
        this.$message.warning('请输入新进货价');
        return false;
      }

      if (this.auditData.newPrice <= 0) {
        this.$message.warning('京东价必须大于0');
        return false;
      }

      if (this.auditData.newCostPrice <= 0) {
        this.$message.warning('进货价必须大于0');
        return false;
      }

      return true;
    },

    // 关闭弹窗前确认
    handleCloseDialog(done) {
      if (this.auditLoading) {
        this.$message.warning('正在处理中，请稍候');
        return;
      }

      done();
    },
    resetListParams() {
      this.params = {
        current: 1,
        size: 10,
        skuId: "",
        mobile: ""
      }
      this.getGoodPriceFeedBackList();
    },
    async getGoodPriceFeedBackList() {
      this.params.startCreateTime = ""
      this.params.endCreateTime = ""
      this.loading = true;
      this.loadingMsg = "列表加载中...";
      this.params.startCreateTime = this.value2.length > 0 ? `${+this.value2[0]}`.slice(0, 10) : ""
      this.params.endCreateTime = this.value2.length > 0 ? `${+this.value2[1]}`.slice(0, 10) : ""
      let data = await getGoodPriceFeedBackApi(this.params);
      this.rows = data.data
      this.size = data.size
      this.current = data.current
      this.total = data.total
      this.loading = false;
    },
    /**
     * 分页大小切换时触发
     * @param val
     */
    handleSizeChange(val) {
      this.params.size = val;
      this.getGoodPriceFeedBackList();
    },
    /**
     * 页码切换时触发
     * @param val
     */
    handleCurrentChange(val) {
      this.params.current = val;
      this.getGoodPriceFeedBackList();
    },
  },
  created() {
    this.getGoodPriceFeedBackList();
  }
}
</script>
<style>
.el-table .warning-row {
  background: palevioletred;
}

.el-table .success-row {
  background: green;
}

/* 弹窗样式 */
.product-info img {
  border-radius: 8px;
  border: 1px solid #eee;
}

.price-info .row {
  margin-bottom: 8px;
}

.price-info label {
  font-size: 14px;
}

.audit-section .el-textarea {
  margin-bottom: 16px;
}

.audit-section .el-input-number {
  margin-left: 8px;
}
</style>